const secondaryIntentRouting = {
  activeEntries: [
    {
      key: "videochamadaAoVivo",
      path: "/acompanhantes-virtuais/videochamada-ao-vivo/",
      label: "Videochamada ao vivo",
    },
    {
      key: "chamadaDeVozPrivada",
      path: "/acompanhantes-virtuais/chamada-de-voz-privada/",
      label: "Chamada de voz privada",
    },
    {
      key: "videochamadaComAgendamento",
      path: "/acompanhantes-virtuais/videochamada-com-agendamento/",
      label: "Videochamada com agendamento",
    },
    {
      key: "chatPrivadoImediato",
      path: "/acompanhantes-virtuais/chat-privado-imediato/",
      label: "Chat privado imediato",
    },
    {
      key: "chamadaDeVozComAgendamento",
      path: "/acompanhantes-virtuais/chamada-de-voz-com-agendamento/",
      label: "Chamada de voz com agendamento",
    },
    {
      key: "conteudoSobMedidaOnline",
      path: "/acompanhantes-virtuais/conteudo-sob-medida-online/",
      label: "Conteudo sob medida online",
    },
    {
      key: "videochamadaPrivada",
      path: "/acompanhantes-virtuais/videochamada-privada/",
      label: "Videochamada privada",
    },
    {
      key: "chatPrivadoDiscreto",
      path: "/acompanhantes-virtuais/chat-privado-discreto/",
      label: "Chat privado discreto",
    },
    {
      key: "conteudoPersonalizadoComRoteiro",
      path: "/acompanhantes-virtuais/conteudo-personalizado-com-roteiro/",
      label: "Conteudo personalizado com roteiro",
    },
  ],
  legacyRedirects: {
    "/acompanhantes-virtuais/chat-online-privado/": "/acompanhantes-virtuais/chat-privado/",
    "/acompanhantes-virtuais/conteudo-personalizado-sob-demanda/":
      "/acompanhantes-virtuais/conteudo-personalizado/",
    "/acompanhantes-virtuais/atendimento-reservado-online/":
      "/acompanhantes-virtuais/atendimento-discreto/",
    "/acompanhantes-virtuais/perfis-verificados-online-seguro/":
      "/acompanhantes-virtuais/perfis-verificados/",
    "/acompanhantes-virtuais/chamada-de-voz-segura/":
      "/acompanhantes-virtuais/chamada-de-voz/",
    "/acompanhantes-virtuais/conteudo-personalizado-exclusivo/":
      "/acompanhantes-virtuais/conteudo-personalizado/",
    "/acompanhantes-virtuais/atendimento-discreto-sem-exposicao/":
      "/acompanhantes-virtuais/atendimento-discreto/",
    "/acompanhantes-virtuais/perfis-com-identidade-verificada/":
      "/acompanhantes-virtuais/perfis-verificados/",
    "/acompanhantes-virtuais/videochamada-imediata/":
      "/acompanhantes-virtuais/videochamada-ao-vivo/",
    "/acompanhantes-virtuais/chat-privado-seguro/":
      "/acompanhantes-virtuais/chat-privado/",
    "/acompanhantes-virtuais/ligacao-privada-online/":
      "/acompanhantes-virtuais/chamada-de-voz-privada/",
  },
};

module.exports = secondaryIntentRouting;
module.exports.default = secondaryIntentRouting;
